import axios from 'axios';

export const setAuthorizationToken = (token = false) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    // IE cache fix
    axios.defaults.headers.common['Cache-Control'] = 'no-cache,no-store';

    axios.defaults.headers.common['Pragma'] = 'no-cache';
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

export const updateLocalStorage = (
  token = false,
  refreshToken = null,
  username = false,
  firstName,
  lastName,
  refId,
) => {
  if (token) {
    localStorage.setItem('auth/token', token);
    localStorage.setItem('auth/refreshToken', refreshToken);
  } else {
    localStorage.removeItem('auth/token');
    localStorage.removeItem('auth/token-v2');
    localStorage.removeItem('auth/refreshToken');
    localStorage.removeItem('legacy/activeSession');
  }

  if (username) {
    localStorage.setItem('auth/username', username);
    localStorage.setItem('auth/firstName', firstName);
    localStorage.setItem('auth/lastName', lastName);
  } else {
    localStorage.removeItem('auth/username');
    localStorage.removeItem('auth/firstName');
    localStorage.removeItem('auth/lastName');
  }

  if (refId) {
    localStorage.setItem('auth/refId', refId);
  } else {
    localStorage.removeItem('auth/refId');
  }
};

export const updateLocalStorageTerms = userMustAcceptTerms => {
  if (userMustAcceptTerms !== null && userMustAcceptTerms !== undefined) {
    localStorage.setItem('auth/userMustAcceptTerms', userMustAcceptTerms);
  } else {
    localStorage.removeItem('auth/userMustAcceptTerms');
  }
};

//Fix for NP 356
export const updateSessionStorage = (roleId, roleTitle) => {
  sessionStorage.setItem('roleId', roleId);
  sessionStorage.setItem('roleTitle', roleTitle);
};

export const rememberMe = (username = false) => {
  if (username) localStorage.setItem('login/username', username);
  else localStorage.removeItem('login/username');
};

// Store the cost center and country to retain on refresh
export const updateCostCenterCountryInSessionStorage = data => {
  sessionStorage.setItem('country', JSON.stringify(data.country));
  sessionStorage.setItem('costcenter', JSON.stringify(data.costcenter));
};



// WEBPACK FOOTER //
// ./src/auth/persistance.js